module.exports = __webpack_public_path__ + "static/media/search-circle.8ed315ab.svg";